import React from 'react';
import {Stack, Typography} from '@mui/material';
import {carbOptions} from '../constants/carbOptions';
import CustomCard from './customCard';
import Carousel from './carousel';
import _ from 'lodash';
import 'react-glidejs/dist/index.css';

const Preworkout = () => {
  const typesOfSupplements = _.groupBy(carbOptions, 'type');
  const prep = typesOfSupplements['prep'];

  return (
    <Stack>
      <Typography variant="h6">Pre-workout</Typography>
      <Carousel>
        {prep.map((supp, index) => <CustomCard key={index} metadata={supp} />)}
      </Carousel>
    </Stack>
  );
};

export default Preworkout;
